
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub/cookies-info",
      function () {
        return require("private-next-pages/sub/cookies-info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub/cookies-info"])
      });
    }
  